/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DeleteConversation200Response
 */
export interface DeleteConversation200Response {
    /**
     * 
     * @type {boolean}
     * @memberof DeleteConversation200Response
     */
    success?: boolean;
}

/**
 * Check if a given object implements the DeleteConversation200Response interface.
 */
export function instanceOfDeleteConversation200Response(value: object): value is DeleteConversation200Response {
    return true;
}

export function DeleteConversation200ResponseFromJSON(json: any): DeleteConversation200Response {
    return DeleteConversation200ResponseFromJSONTyped(json, false);
}

export function DeleteConversation200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeleteConversation200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'] == null ? undefined : json['success'],
    };
}

export function DeleteConversation200ResponseToJSON(json: any): DeleteConversation200Response {
    return DeleteConversation200ResponseToJSONTyped(json, false);
}

export function DeleteConversation200ResponseToJSONTyped(value?: DeleteConversation200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
    };
}

